import ApartTemplate from 'componentsForThree/ApartTemplate';
import Ground from 'componentsForThree/Ground';
import Trees from 'componentsForThree/Trees';
import { citySize, mapSizeX } from 'constant/env';
import gsap from 'gsap';
import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext, useEffect, useRef, useState } from 'react';

type Props = {
  index?: number;
};

function City({ index = 0 }: Props) {
  const { setCurrentIndex, currentIndex, allCity, navIndex, setNavIndex } =
    useContext(ControlContext);
  const [hovered, setHover] = useState<boolean>(false);
  const meshRef = useRef<any>(null);
  useEffect(() => {
    if (hovered)
      gsap.to(meshRef.current.position, {
        y: 2,
        duration: 1,
        ease: 'poweer1.out',
      });
    else if (!hovered && meshRef.current)
      gsap.to(meshRef.current.position, {
        y: 0,
        duration: 1,
        ease: 'poweer1.out',
      });
  }, [hovered]);
  useEffect(() => {
    if (!allCity && meshRef.current) {
      gsap.fromTo(
        meshRef.current.position,
        { y: -20 },
        {
          y: 0,
          duration: 1,
          ease: 'poweer2.out',
        }
      );
    }
  }, [meshRef]);
  return (
    <group
      ref={meshRef}
      position={[
        (index % mapSizeX) * citySize,
        0,
        Math.floor(index / mapSizeX) * citySize,
      ]}
      scale={[1, 1, 1]}
    >
      <group
        onPointerOver={(e) => {
          e.stopPropagation();
          if (navIndex === 0) setHover(true);
        }}
        onPointerOut={() => {
          if (hovered) setHover(false);
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (navIndex !== 2) {
            setCurrentIndex(index);
            setNavIndex(2);
          }
        }}
      >
        <Ground
          selected={
            navIndex === 0 ? true : currentIndex === index ? true : false
          }
        />
      </group>
      <ApartTemplate pos={[0.4, 0.5, -0.36]} />
      <ApartTemplate pos={[-0.3, 0.5, -0.36]} />
      <ApartTemplate pos={[-1, 0.5, -0.36]} />
      <ApartTemplate pos={[-2.45, 0.5, -0.36]} />
      <ApartTemplate pos={[-2.45, 0.5, 1]} />
      <ApartTemplate pos={[-1, 0.5, 1]} />
      <ApartTemplate pos={[-0.3, 0.5, 1]} />
      <ApartTemplate pos={[0.4, 0.5, 1]} />
      <ApartTemplate pos={[1.7, 0.5, 1]} />
      <ApartTemplate pos={[0.4, 0.5, 1.75]} />
      <ApartTemplate pos={[0.4, 0.5, 2.5]} />
      <ApartTemplate pos={[-1, 0.5, 1.75]} />
      <ApartTemplate pos={[-1, 0.5, 2.5]} />
      <ApartTemplate pos={[1.7, 0.5, -0.36]} />
      <Trees pos={[1.8, 0, 2]} />
      <Trees pos={[1.8, 0, 2]} />
      <Trees pos={[-1.8, 0, 2.2]} rot={[0, Math.PI, 0]} />
      <Trees pos={[-2.2, 0, -1.8]} rot={[0, Math.PI / 2, 0]} />
      <Trees pos={[0.6, 0, -1.8]} rot={[0, Math.PI / 2, 0]} />
      <Trees pos={[0, 0, -1.8]} rot={[0, Math.PI / 2, 0]} />
      <Trees pos={[2.3, 0, -2.2]} rot={[0, -Math.PI / 2, 0]} />
      <Trees pos={[-0.6, 0, -1.8]} rot={[0, Math.PI / 2, 0]} />
    </group>
  );
}

export default memo(City);
